import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Tailwind class merge helper. Combines clsx (conditional classes) with
 * tailwind-merge (de-duplicates competing utility classes).
 *
 * @example
 *   cn("p-2", isActive && "bg-primary", "p-4") // → "bg-primary p-4"
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
